import { Text, Timestamp } from '@dixa/lib-shared-habla';
import React from 'react';

import { useServerStorage } from 'utils/useServerStorage';

interface ConversationTimestampProps extends React.ComponentProps<
  typeof Timestamp
> {
  textProps?: Partial<React.ComponentProps<(typeof Text)['Paragraph']>>;
  shouldDateFormatPersist?: boolean;
}

export const ConversationTimestamp: React.FC<ConversationTimestampProps> = ({
  textProps,
  shouldDateFormatPersist = false,
  ...timestampProps
}) => {
  const storage = useServerStorage('user');

  const handleFormatChange = (format) => {
    storage.set({
      conversation: (draft) => {
        draft.timestampFormat = format;
      },
    });
  };

  return (
    <Text.Paragraph variant="4" subdued {...textProps}>
      <Timestamp
        customFormatters={{
          absolute: 'D MMMM · HH:mm:ss',
          full: 'MMM D, YYYY · hh:mm:ss A',
        }}
        {...timestampProps}
        {...(shouldDateFormatPersist && {
          initialFormat: storage.data.conversation?.timestampFormat,
          onClick: handleFormatChange,
        })}
      />
    </Text.Paragraph>
  );
};
